import { SEASONS, type SeasonId } from '@somnhold/content';
import { idiv } from './math/fixed.ts';

const DAY_MS = 86_400_000;

/** UTC calendar date of a day count since 1970-01-01 (Howard Hinnant's civil-from-days, integers only). */
const civil = (days: number): { y: number; m: number; d: number } => {
  const z = days + 719468;
  const era = idiv(z, 146097);
  const doe = z - era * 146097;
  const yoe = idiv(doe - idiv(doe, 1460) + idiv(doe, 36524) - idiv(doe, 146096), 365);
  const doy = doe - (365 * yoe + idiv(yoe, 4) - idiv(yoe, 100));
  const mp = idiv(5 * doy + 2, 153);
  const d = doy - idiv(153 * mp + 2, 5) + 1;
  const m = mp < 10 ? mp + 3 : mp - 9;
  return { y: yoe + era * 400 + (m <= 2 ? 1 : 0), m, d };
};

/** Month and day as one comparable number (Oct 24 → 1024). */
const md = (m: number, d: number): number => m * 100 + d;

/**
 * The season at a real moment (ms since the epoch, an input like every other clock in the campaign),
 * or null on an ordinary day.
 */
export const seasonAt = (ms: number): SeasonId | null => {
  const days = idiv(ms, DAY_MS);
  const today = civil(days);
  const msInDay = ms - days * DAY_MS;
  const yesterday = civil(days - 1);
  for (const s of SEASONS) {
    const from = md(s.from[0], s.from[1]);
    const to = md(s.to[0], s.to[1]);
    const t = md(today.m, today.d);
    if (from <= to ? t >= from && t <= to : t >= from || t <= to) return s.id;
    // The early hours after the last day still count.
    if (md(yesterday.m, yesterday.d) === to && msInDay < s.graceHours * 3_600_000) return s.id;
  }
  return null;
};
